export default __webpack_public_path__ + "static/slider3-bd42236d6ca59da6af754ac12ea70023.jpg";